'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dStore$002dCart$002dState from "./mealorama.-Store-Cart-State.js";
var $p;
/** @constructor */
function $c_Lmealorama_StoreCartState$$anon$1(\u03b4name$3, _$ordinal$3) {
  this.ZF = null;
  this.ZF = \u03b4name$3;
}
export { $c_Lmealorama_StoreCartState$$anon$1 as $c_Lmealorama_StoreCartState$$anon$1 };
$p = $c_Lmealorama_StoreCartState$$anon$1.prototype = new $j_mealorama$002e$002dStore$002dCart$002dState.$h_Lmealorama_StoreCartState();
$p.constructor = $c_Lmealorama_StoreCartState$$anon$1;
/** @constructor */
function $h_Lmealorama_StoreCartState$$anon$1() {
}
export { $h_Lmealorama_StoreCartState$$anon$1 as $h_Lmealorama_StoreCartState$$anon$1 };
$h_Lmealorama_StoreCartState$$anon$1.prototype = $p;
$p.q = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.r = (function() {
  return this.ZF;
});
$p.m = (function() {
  return this.ZF;
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.ZF);
});
var $d_Lmealorama_StoreCartState$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartState$$anon$1, "mealorama.StoreCartState$$anon$1", ({
  H9: 1,
  k3: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  n: 1,
  d: 1,
  e: 1,
  h: 1
}));
export { $d_Lmealorama_StoreCartState$$anon$1 as $d_Lmealorama_StoreCartState$$anon$1 };
//# sourceMappingURL=mealorama.-Store-Cart-State$$anon$1.js.map
